import { render, staticRenderFns } from "./Medical.vue?vue&type=template&id=249f1bbf&scoped=true&"
import script from "./Medical.vue?vue&type=script&lang=js&"
export * from "./Medical.vue?vue&type=script&lang=js&"
import style0 from "./Medical.vue?vue&type=style&index=0&id=249f1bbf&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "249f1bbf",
  null
  
)

export default component.exports